module.exports = __webpack_public_path__ + "static/img/wechat_btn.28efc9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/online/wechat_btn.png
// module id = bwoR
// module chunks = 1